import { create } from 'zustand';

export type RydMidiAccess = {
    inputs,
    outputs,
    sysexEnabled,
    onstatechange
}

export type MidiAccessState = {
    midiAccess?: RydMidiAccess,
    setMidiAccess: (midiAccess: RydMidiAccess) => void,
};

export const useMidiAccessStore = create<MidiAccessState>((set) => ({
    midiAccess: undefined,
    setMidiAccess: (midiAccess) => set({ midiAccess }),
}));

// export function hasMidiAccess(): boolean {
//     const midiAccess = useMidiAccessStore.getState().midiAccess;
//     return !!midiAccess;
// }

// export function getMidiAccess(): RydMidiAccess | undefined {
//     return useMidiAccessStore.getState().midiAccess;
// }

export function setMidiAccess(midiAccess: RydMidiAccess) {
    useMidiAccessStore.getState().setMidiAccess(midiAccess);
}
